// BEGIN McTheme
class McTheme {
  constructor() {
    this.header = document.getElementById('header');
    
    this.init();
  }
  
  init() {
		this.handleResize();
		this.bindEvents();
    this.headerSearch();

    document.querySelectorAll('.option-dropdown').forEach(wrapper => {
			new OptionDropdown(wrapper);
    });

    document.querySelectorAll('.image-carousel-section').forEach(wrapper => {
			new ImageCarousel(wrapper);
    });

    if (window.jQuery) {
      this.initJQueryHooks(window.jQuery);
    }
  }
	
	bindEvents() {
    window.addEventListener('resize', () => {
      this.handleResize();
    });
  }

  handleResize() {
    const doc = document.documentElement;

    const windowWidth = document.documentElement.clientWidth;
    const windowHeight = window.innerHeight;
    
    doc.style.setProperty('--mc-window-width', `${windowWidth}px`);
    doc.style.setProperty('--mc-window-height', `${windowHeight}px`);

    jQuery(window).trigger('resize.bg-video');
  }

  headerSearch() {
    const toggleBtn = this.header.querySelector('.toggle-search');
    const form = this.header.querySelector('.search-form');
    const input = form?.querySelector('.search-form__input');

    if (!toggleBtn || !form) return;

    const openSearch = () => {
      toggleBtn.classList.add('active');
      form.classList.add('show');

      setTimeout(() => {
        input?.focus();
      }, 200);
    };

    const closeSearch = () => {
      toggleBtn.classList.remove('active');
      form.classList.remove('show');
    };

    const toggleSearch = () => {
      const isOpen = form.classList.contains('show');

      if (isOpen) {
        closeSearch();
      } else {
        openSearch();
      }
    };

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      toggleSearch();
    });

    form.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    document.addEventListener('click', () => {
      closeSearch();
    });
  }
  
  initJQueryHooks($) {
    $(document).ready(() => {
      if ($('.product-navigation').length) {
        $('.product-navigation').sticky({
          topSpacing: 0,
          zIndex: 1000
        });
      }
    });
  }
}

// BEGIN FlyoutMenu
class FlyoutMenu {
  constructor() {
    this.wrapper = document.getElementById('flyout-menu');
    if (!this.wrapper) return;

    this.toggleBtn = document.querySelector('#header .toggle-nav');

    this.init();
  }
  
  init() {
    this.bindEvents();
  }
  
  bindEvents() {
    this.wrapper.querySelectorAll('.toggle').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const subMenu = btn.nextElementSibling;
        if (!subMenu) return;

        const isActive = btn.classList.contains('active');

        this.wrapper.querySelectorAll('.toggle').forEach((otherBtn) => {
          otherBtn.classList.remove('active');

          const otherSubMenu = otherBtn.nextElementSibling;

          if (otherSubMenu) {
            otherSubMenu.classList.remove('show');
          }
        });
        
        if (!isActive) {
          btn.classList.add('active');
          subMenu.classList.add('show');
        }
      });
    });
    
    if (this.toggleBtn) {
      this.wrapper.addEventListener('show.bs.offcanvas', (e) => {
        this.toggleBtn.classList.add('active');
      });

      this.wrapper.addEventListener('hide.bs.offcanvas', (e) => {
        this.toggleBtn.classList.remove('active');
      });
    }
  }
}

// BEGIN OptionDropdown
class OptionDropdown {
  constructor(wrapper) {
    this.wrapper = wrapper;

    this.toggleBtn = this.wrapper.querySelector('.option-dropdown__toggle');
    this.inputs = this.wrapper.querySelectorAll('input[type="radio"]');

    this.init();
  }
  
  init() {
    this.bindEvents();
    this.updateNav();
  }
  
  bindEvents() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const label = input.previousElementSibling;

        if (label) {
          this.toggleBtn.innerHTML = label.innerHTML;
        }
        
        this.updateNav();
      });
    });
  }

  updateNav() {
    const navWrapper = document.querySelector('.product-navigation');
    if (!navWrapper) return;

    const cartWrapper = navWrapper.querySelector('.add-cart');
    if (!cartWrapper) return;

    let optionsEl = cartWrapper.querySelector('.add-cart__options');

    if (!optionsEl) {
      optionsEl = document.createElement('div');
      optionsEl.className = 'add-cart__options d-flex align-items-center';
      cartWrapper.prepend(optionsEl);
    }

    const checkedInputs = document.querySelectorAll('.product-info__options input[type="radio"]:checked');

    optionsEl.innerHTML = Array.from(checkedInputs).map((input) => {
      const label = input.previousElementSibling;
      const title = label?.querySelector('span:first-child')?.textContent.trim();

      return `<span class="add-cart__option">${title}</span>`;
    }).join('');
  }
}

// BEGIN ImageCarousel
class ImageCarousel {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.swiper = wrapper.querySelector('.swiper');

    this.init();
  }
  
  init() {
    if (!this.swiper) return;

    this.slider = new Swiper(this.swiper, {
      slidesPerView: 2,
      spaceBetween: 12,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: this.wrapper.querySelector('.swiper-button-next'),
        prevEl: this.wrapper.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 12
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 12
        }
      }
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	new McTheme();
  new FlyoutMenu();
});